export enum Stimp {
  Count = "COUNT",
  Length6 = "LENGTH6",
  Length7 = "LENGTH7",
  Length8 = "LENGTH8",
  Length9 = "LENGTH9",
  Length10 = "LENGTH10",
  Length11 = "LENGTH11",
  Length12 = "LENGTH12",
  None = "NONE",
}

export const greenStimpMap = {
  [Stimp.Count]: "Count",
  [Stimp.None]: "None",
  [Stimp.Length6]: "6",
  [Stimp.Length7]: "7",
  [Stimp.Length8]: "8",
  [Stimp.Length9]: "9",
  [Stimp.Length10]: "10",
  [Stimp.Length11]: "11",
  [Stimp.Length12]: "12",
};
